import { Routes } from '@angular/router';

export const MAIN_ROUTES: Routes = [
  {
    path: 'create',
    loadComponent: () =>
      import('../components/order-components/create-order/create-order.component').then(
        (mod) => mod.CreateOrderComponent,
      ),
  },

  {
    path: 'notifications',
    loadComponent: () =>
      import('../components/notification-component/notification-component').then(
        (mod) => mod.NotificationComponent,
      ),
  },
  {
    path: 'files',
    loadComponent: () =>
      import('../components/file-manager-component/file-manager-component').then(
        (mod) => mod.FileManagerComponent,
      ),
  },
  {
    path: 'create/:orderID',
    loadComponent: () =>
      import('../components/order-components/create-order/create-order.component').then(
        (mod) => mod.CreateOrderComponent,
      ),
  },
  {
    path: 'user',
    loadComponent: () =>
      import('../components/order-components/customer-data/customer-data.component').then(
        (mod) => mod.CustomerDataComponent,
      ),
  },

  {
    path: 'suppliers',
    loadComponent: () =>
      import('../components/purchase-components/supplier-administration/supplier-administration').then(
        (mod) => mod.SupplierAdministration,
      ),
  },
  {
    path: 'purchase/:id',
    loadComponent: () =>
      import('../components/purchase-components/purchase-items/purchase-items').then(
        (mod) => mod.PurchaseItems,
      ),
  },
  {
    path: 'purchase',
    loadComponent: () =>
      import('../components/purchase-components/purchase-module/purchase-module').then(
        (mod) => mod.PurchaseModule,
      ),
  },
  {
    path: 'correction-requests',
    loadComponent: () =>
      import('../components/purchase-components/purchase-module/purchase-module').then(
        (mod) => mod.PurchaseModule,
      ),
  },
  {
    path: 'orders/:id',
    loadComponent: () =>
      import('../components/order-components/order-details-new/order-details-new').then(
        (mod) => mod.OrderDetailsNew,
      ),
  },
  {
    path: 'edit-user',
    loadComponent: () =>
      import('../components/edit-user/edit-user.component').then((mod) => mod.EditUserComponent),
  },
  {
    path: 'edit-coins-new',
    loadComponent: () =>
      import('../features/product/pages/edit-products-new/edit-products-new.component').then(
        (mod) => mod.EditProductsNewComponent,
      ),
  },
  {
    path: 'orders',
    loadComponent: () =>
      import('../components/order-components/edit-order-new/edit-order-new.component').then(
        (mod) => mod.EditOrderNewComponent,
      ),
  },
  {
    path: 'close-period',
    loadComponent: () =>
      import('../components/order-components/close-period/close-period').then(
        (mod) => mod.ClosePeriod,
      ),
  },
  {
    path: 'import',
    loadComponent: () =>
      import('../components/imports/imports.component').then((mod) => mod.ImportsComponent),
  },
  {
    path: 'new-purchase',
    loadComponent: () =>
      import('../components/purchase-components/purchase/purchase').then((mod) => mod.Purchase),
  },
  {
    path: 'convolut',
    loadComponent: () =>
      import('../components/convolut/convolut.component').then((mod) => mod.ConvolutComponent),
  },
  {
    path: 'tracking',
    loadComponent: () =>
      import('../components/tracking/tracking.component').then((mod) => mod.TrackingComponent),
  },
  {
    path: 'shop',
    loadComponent: () =>
      import('../components/shop/shop.component').then((mod) => mod.ShopComponent),
  },
  {
    path: 'accounting',
    loadComponent: () =>
      import('../components/transactions/accounting/accounting.component').then(
        (mod) => mod.AccountingComponent,
      ),
  },
  {
    path: 'accounting-setup',
    loadComponent: () =>
      import('../components/transactions/accounting/accounting-setup-page.component').then(
        (mod) => mod.AccountingSetupPageComponent,
      ),
  },
  {
    path: 'cashflow',
    loadComponent: () =>
      import('../components/auswertung/cashflow/cashflow.component').then(
        (mod) => mod.CashflowComponent,
      ),
  },
  {
    path: 'unassigned',
    loadComponent: () =>
      import('../components/transactions/unassigned/unassigned.component').then(
        (mod) => mod.UnassignedComponent,
      ),
  },
  {
    path: 'statistics',
    loadChildren: () => import('./analysis_routes').then((mod) => mod.STATISTICS_ROUTES),
  },
  {
    path: 'archive',
    loadChildren: () => import('./archive.routes').then((mod) => mod.routes),
  },
  {
    path: 'admin',
    loadComponent: () =>
      import('../components/admin/administration/administration').then((mod) => mod.Administration),
  },
  {
    path: 'admin',
    loadChildren: () =>
      import('../features/product/product-admin.routes').then((mod) => mod.PRODUCT_ADMIN_ROUTES),
  },
  {
    path: 'correction-request',
    loadComponent: () =>
      import('../components/purchase-components/purchase/purchase').then((mod) => mod.Purchase),
  },
  {
    path: 'invoice',
    loadComponent: () =>
      import('../components/excel-viewer/excel-viewer').then((mod) => mod.ExcelViewer),
  },
  { path: '**', redirectTo: 'create' },
];
